'use client'

import { createContext, ReactNode, useContext, useState } from 'react'

const BlockPageSidebarContext = createContext<{
  isOpen: boolean
  setIsOpen: (open: boolean) => void
  isMobileOpen: boolean
  setMobileOpen: (open: boolean) => void
}>({
  isOpen: false,
  setIsOpen: () => {},
  isMobileOpen: false,
  setMobileOpen: () => {},
})

export const useBlockPageSidebar = () => useContext(BlockPageSidebarContext)

export function BlockPageSidebarProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(true)
  const [isMobileOpen, setMobileOpen] = useState(false)

  return (
    <BlockPageSidebarContext.Provider value={{ isOpen, setIsOpen, isMobileOpen, setMobileOpen }}>
      {children}
    </BlockPageSidebarContext.Provider>
  )
}

export default function BlockPageLayoutContent({ children }: { children: ReactNode }) {
  const { isOpen } = useBlockPageSidebar()

  return (
    <div
      className={`grid grid-cols-1 col-span-2 relative transition-all duration-300 ${isOpen ? 'lg:pr-72' : ''}`}
    >
      {children}
    </div>
  )
}
